import React from 'react';

function RewardIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} fill="currentColor" viewBox="0 0 15.258 16.782">
            <path d="M1.907,0A1.908,1.908,0,0,0,0,1.907V3.68a2.289,2.289,0,0,0,1.178,2l4.388,2.44a4.577,4.577,0,1,0,4.126,0l4.39-2.438a2.289,2.289,0,0,0,1.176-2V1.907A1.908,1.908,0,0,0,13.351,0ZM6.1,6.671V1.526H9.155V6.671l-1.526.848Zm4.577,5.536a3.052,3.052,0,1,1-.894-2.158A3.051,3.051,0,0,1,10.68,12.206Z"/>
        </svg>
    );
}

export default RewardIcon;
